{
  "es": {
    "project": {
      "actions": {
        "activate": "Activar",
        "addProjectMaintainer": "Añadir administrador del proyecto",
        "add_as_partner": "Añadir como colaborador",
        "add_as_partner_description": "¿Seguro que quieres añadir a {partner} como colaborador de este proyecto?",
        "add_project_partner": "Añadir colaborador del proyecto",
        "additional_information": "Información adicional",
        "changeProjectLogin": "Cambiar imagen del proyecto",
        "changeProjectLogo": "Cambiar logotipo del proyecto",
        "deactivate": "Desactivar",
        "edit": "Editar",
        "finishRequest": "Enviar solicitud",
        "follow": "Seguir",
        "giveAccess": "Dar acceso",
        "maintainerAdd": "Añadir mantenedor del proyecto",
        "maintainerAddDescription": "¿Seguro que quieres dar acceso a este proyecto a {maintainer}?",
        "maintainerRemove": "Eliminar mantenedor del proyecto",
        "maintainerRemoveDescription": "¿Seguro que quieres revocar el acceso a este proyecto de {maintainer}?",
        "new": "Proyecto",
        "next": "Siguiente",
        "remove_partner": "Eliminar a {partner}",
        "remove_project_partner": "Eliminar colaborador del proyecto",
        "remove_project_partner_description": "¿Seguro que quieres eliminar a {partner} de los colaboradores del proyecto?",
        "selectOption": "Seleccionar opción",
        "selectTemplate": "Seleccionar plantilla",
        "submit": "Crear proyecto",
        "unFollow": "Dejar de seguir"
      },
      "attributes": {
        "address": "Dirección",
        "currency": "Moneda",
        "delivery_date_actual": "Fecha de finalización prevista",
        "delivery_date_contractual": "Fecha de finalización contractual",
        "description": "Descripción",
        "internal_note": "Nota interna del proyecto",
        "measurement": "Unidad de medida",
        "name": "Nombre",
        "picture_login_url": "Imagen del proyecto",
        "picture_logo_url": "Logotipo del proyecto",
        "quotity_total": "Importe total de transmisión",
        "skip_building": "Ocultar edificio",
        "skip_lot": "Ocultar parcela",
        "skip_phase": "Ocultar fase",
        "skip_unit": "Ocultar unidad (proyecto de una sola unidad)",
        "start_date": "Fecha de inicio",
        "units_count": "Número de unidades creadas",
        "units_count_max": "Número máximo de unidades",
        "vat_percentage": "% de IVA",
        "website_url": "URL del sitio web"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Se ha alcanzado el límite de capacidad. Ponte en contacto con nosotros."
        }
      },
      "import": {
        "add": "+ Añadir",
        "add_instead": "En realidad quiero añadir {levels}",
        "building": "edificio",
        "buildings": "edificios",
        "changed_mind": "Omitir este nivel",
        "create_new": "¿Cuál es el nombre de {type}?",
        "download_template": "Descargar plantilla de importación",
        "drop_or_upload": "Suelta la plantilla aquí o haz clic para subirla",
        "error_line": "Error en la línea",
        "fill_space_info": "Rellena la plantilla con la información de los anejos",
        "fill_unit_info": "Rellena la plantilla con la información de las unidades",
        "file_unreadable": "No se ha podido leer este archivo. Compruebe que sea una hoja de cálculo válida e inténtelo de nuevo",
        "fix_file_upload": "Corrige los problemas y vuelve a subir el archivo.</br>Las unidades existentes no se eliminarán, pero se actualizarán si algo ha cambiado en el archivo para esa unidad desde la última subida.",
        "fix_file_upload_space": "Corrige los problemas y vuelve a subir el archivo.</br>Los anejos existentes no se eliminarán, pero se actualizarán si algo ha cambiado en el archivo para ese anejo desde la última subida.",
        "for": "para",
        "import_column_title": "¿Quieres añadir {column_type}?",
        "import_partial_success": "La importación se ha completado parcialmente. A continuación se muestran los errores restantes:",
        "import_spaces": "Importar anejos",
        "import_units": "Importar unidades para",
        "lot": "parcela",
        "lots": "parcelas",
        "no": "no",
        "noLevels": "Sin {levels}",
        "phase": "fase",
        "phases": "fases",
        "plot": "parcela",
        "select_level_above": "Selecciona {level} para continuar",
        "start_upload": "Iniciar subida",
        "step": "Paso",
        "unit_info": "Podrás importar unidades una vez que se haya creado el proyecto",
        "unit_limit": "Quieres importar más unidades de las permitidas. Elimina {exceeded_by} unidad(es) o pídenos que aumentemos tu número de unidades permitidas",
        "units": "unidades",
        "upload_filled_template": "Subir plantilla rellenada",
        "upload_new_file": "Subir nuevo archivo",
        "upload_spaces": "Subir anejos",
        "upload_units": "Subir unidades",
        "uploaded_file": "Archivo subido",
        "validations_failed": "Algunas validaciones han fallado",
        "yes": "sí"
      },
      "labels": {
        "activate": "Activar proyecto",
        "checkLevels": "Marca los niveles que quieras añadir:",
        "companyInfo": "Información de la organización",
        "companyNameTitle": "Nombre de la organización",
        "congratulationsNewProject": "Enhorabuena por tu nuevo proyecto",
        "copyFromTemplate": "Copiar desde el proyecto plantilla (opcional)",
        "customer_can_create_issue": "El cliente puede crear incidencias",
        "customersCanLogIn": "Los clientes de este proyecto pueden iniciar sesión con",
        "deactivate": "Desactivar proyecto",
        "deactivated": "Desactivado",
        "deactivatedProjects": "Proyectos desactivados",
        "download_export": "Descargar mi exportación",
        "downloading_export": "Descargando",
        "endsOn": "Termina el {enddate}",
        "export_expiration": "Los datos de tu exportación están listos para descargar. Estarán disponibles hasta las {time}",
        "export_explanation": "Solicita una exportación de todos tus datos, incluidas conversaciones y documentos.",
        "export_failed": "Error al exportar",
        "export_file": "Exportar mi archivo",
        "export_notification_snack": "Recopilar tu archivo puede tardar unos minutos. Recibirás una notificación cuando esté listo para descargar.",
        "export_prepared": "Los datos de tu exportación estarán listos para descargar en breve.",
        "export_preparing": "Preparando exportación",
        "filterProject": "Selecciona un proyecto",
        "finalSteps": "Últimos pasos",
        "follow": "Sigue {project} para recibir notificaciones.",
        "followedProjects": "Mis proyectos",
        "following": "Siguiendo",
        "general": "General",
        "importContacts": "Sí, quiero importar los contactos de los clientes",
        "importInformationSubtitle": "En vez de añadir anejos y contactos uno a uno, podemos ayudarte a importar un archivo CSV. Marca las casillas siguientes y un miembro del equipo de Ziggu se pondrá en contacto contigo.",
        "importInformationTitle": "¿Importar información?",
        "importSpaces": "Sí, quiero importar anejos de aparcamiento y trastero",
        "importUnits": "Sí, quiero importar unidades y su información",
        "included": "Incluido",
        "internal": "Interno",
        "invoice_subtitle": "Solo enviaremos una factura si es necesario, por ejemplo cuando no te queden unidades en tu paquete.",
        "invoice_title": "¿A qué dirección de correo podemos enviarte nuestras facturas?",
        "isTemplateProject": "Este es un proyecto plantilla",
        "levelBuildingExplainer": "Selecciona esto si tienes varias unidades dentro de uno o más edificios.",
        "levelPhaseExplainer": "Selecciona esto si tu proyecto se construye en distintas fases, repartidas en el tiempo.",
        "levelPlotExplainer": "Selecciona esto si tu proyecto consta de varias parcelas de terreno.",
        "levelProjectExplainer": "Tu proyecto es el bloque más grande y es imprescindible para empezar.",
        "levelUnitExplainer": "La unidad es el bloque más pequeño. Es la casa o el piso que estás construyendo para tus clientes.",
        "levels": "Estructura del proyecto",
        "limitReached": "Límite de proyectos alcanzado",
        "multiUnits": "Varias unidades",
        "nameTitle": "¿Cuál es el nombre del proyecto?",
        "newProjectTitle": "¡Vamos a crear tu nuevo proyecto!",
        "noAccess": "No tienes acceso a este proyecto",
        "noFollowedProjects": "Haz clic en el icono de notificaciones para seguir un proyecto.",
        "noProjects": "No se han encontrado proyectos",
        "optional_information": "Información opcional",
        "optional_information_subtitle": "¿Hay algo más que quieras compartir con nosotros?",
        "otherProjects": "Otros proyectos",
        "outOfProjects": "Parece que tu paquete se ha quedado sin proyectos activos.",
        "outOfProjectsContact": "Ponte en contacto con Ziggu para ampliar tu paquete y seguir creando proyectos.",
        "partner_invitation_notice": "Todavía no se ha invitado a {partner}. Se enviará una invitación cuando se añada a {partner} a los colaboradores del proyecto.",
        "pendingProjects": "Se ha solicitado {first_project_name} y Ziggu lo está configurando actualmente | Se han solicitado {count} proyectos y Ziggu los está configurando actualmente",
        "permission_partner_project": "Un colaborador con quien compartir fácilmente documentos y propuestas",
        "permissionsOwnerOnly": "Solo los miembros del equipo con el rol de Propietario pueden añadir nuevos mantenedores del proyecto",
        "permissionsRoleMaintainer": "Un miembro del equipo con acceso a este proyecto",
        "project": "Proyecto {project}",
        "projectBranding": "Identidad visual del proyecto",
        "projectIsDeactivated": "Este proyecto está desactivado",
        "projectMaintainers": "Mantenedores del proyecto",
        "projectName": "Nombre del proyecto",
        "projectStructure": "Estructura del proyecto",
        "projectStructureSubtitle": "Ahora puedes añadir 3 niveles adicionales para organizar mejor tus unidades.</br>Vamos a repasarlos uno a uno, paso a paso.",
        "projectStructureSubtitleOld": "La estructura del proyecto se define una vez, al inicio del proyecto",
        "project_label": "Proyecto",
        "project_partners": "Colaboradores del proyecto",
        "projects": "Proyectos",
        "remove_project_partner_prohibited": "{partner} está añadido a decisiones de este proyecto y no se puede eliminar de los colaboradores del proyecto.",
        "remove_project_partner_prohibited_label": "No se puede eliminar al colaborador del proyecto",
        "searchProject": "Buscar proyecto",
        "searchProjects": "Buscar proyecto",
        "selectATemplateProject": "Selecciona un proyecto plantilla",
        "selected": "Seleccionado",
        "showProject": "Mostrar proyecto",
        "singleUnit": "Una sola unidad",
        "spaces": "Anejos",
        "startsOn": "Empieza el {startdate}",
        "step1Info": "Vamos a repasar algunos detalles para empezar.",
        "step1Title": "¡Enhorabuena por tu nuevo proyecto!",
        "step2Info": "¿A qué organización dirigimos la factura?",
        "step2Title": "Datos de facturación",
        "step3Title": "¿Necesitas niveles intermedios?",
        "step4Info": "¿Qué pasa ahora? Ziggu configurará {project} en 3 a 5 días laborables. Te avisaremos en cuanto todo esté listo.",
        "templateProjects": "Proyectos plantilla",
        "unFollow": "Deja de recibir notificaciones de {project}.",
        "underConstruction": "En construcción",
        "units": "Unidades",
        "unitsActiveRemaining": "UNIDADES DISPONIBLES",
        "unitsAllotted": "UNIDADES ASIGNADAS",
        "unitsCountSubtitle": "¿Cuántas unidades?",
        "unselected": "Haz clic para seleccionar",
        "youAreEditingTemplateProject": "Estás editando un proyecto plantilla",
        "you_have_inbound_emails": "Tienes 1 correo entrante sin procesar | Tienes {number} correos entrantes sin procesar"
      },
      "messages": {
        "units_count_max": "Si quieres crear más unidades, ponte en contacto con nosotros a través del botón de chat."
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "¡Vamos a configurar tu nuevo proyecto!"
          },
          "step_2": {
            "title": "¿Este proyecto contiene una o varias unidades?"
          },
          "step_3": {
            "subtitle": "Haz clic en las tarjetas para activar los niveles intermedios.",
            "title": "¿Necesitas niveles intermedios?"
          },
          "step_4": {
            "info": "Las plantillas de decisiones y encuestas se pueden importar una vez creadas las unidades de este proyecto.",
            "placeholder": "Selecciona un proyecto o deja esto vacío si no quieres copiar de una plantilla",
            "title": "¿Usar una plantilla como base?"
          }
        }
      },
      "navigation": {
        "backToProjects": "Volver a proyectos"
      },
      "notifications": {
        "emailHasBeenCopied": "Dirección de correo copiada",
        "pictureChangedSuccessfully": "La imagen se ha actualizado. Los cambios pueden tardar hasta una hora en ser visibles.",
        "tokenCopied": "Token copiado correctamente",
        "urlHasBeenCopied": "URL copiada correctamente"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "No tienes acceso a ningún proyecto. Pide a un miembro del equipo con el rol de Propietario que te dé acceso.",
            "title": "Sin proyectos"
          }
        },
        "partners": {
          "noProjectSubtitle": "Te avisaremos en cuanto se te asigne un nuevo proyecto",
          "noProjectTitle": "Todavía no hay ningún proyecto"
        }
      },
      "snackbars": {
        "duplicate": "El proceso de copia ha comenzado y puede tardar unos instantes. Actualiza la página al cabo de unos minutos."
      },
      "sort": {
        "nameAsc": "Nombre A → Z",
        "nameDesc": "Nombre Z → A",
        "newest": "Más recientes primero",
        "oldest": "Más antiguos primero"
      },
      "toasts": {
        "activateSuccess": "{project_name} se ha activado correctamente.",
        "deactivateSuccess": "{project_name} se ha desactivado correctamente.",
        "duplicate": "El proyecto se ha creado, pero copiar la plantilla puede tardar unos minutos."
      },
      "tooltip": {
        "hasNoActiveUnits": "No tiene unidades activas",
        "turnOffNotifications": "Desactivar notificaciones de {project}",
        "turnOnNotifications": "Activar notificaciones de {project}"
      },
      "validation": {
        "addressInformationRequired": "Se requiere la información de dirección",
        "companyNeedName": "Se requiere el nombre de la organización",
        "companyNeedVatNumber": "Se requiere el número de IVA",
        "dateAfter": "La fecha debe ser posterior a la fecha de inicio",
        "lessThanOrEqual": "El número debe ser menor o igual que {max_number}",
        "maxLength": "El nombre puede tener como máximo {length} caracteres",
        "nameAlreadyTaken": "Ese nombre ya está en uso en este proyecto",
        "needName": "El título es obligatorio",
        "needNumber": "Debe ser un número (p. ej. 850)",
        "needUnitsCount": "Se requiere el número de unidades"
      }
    }
  }
}
